const SWAGGER_CONSTANTS = {
  username: 'devxuser',
  password: 'devxpass',
};
export default SWAGGER_CONSTANTS;
